export interface SubmitBugReportInput {
  title: string
  description: string
  reporterEmail?: string
  pageUrl: string
  userAgent: string
  screenshots: File[]
}

export interface SubmitBugReportResult {
  id: string
  emailSent: boolean
}

export class BugReportSubmissionError extends Error {
  readonly status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'BugReportSubmissionError'
    this.status = status
  }
}

export async function submitBugReport(
  input: SubmitBugReportInput
): Promise<SubmitBugReportResult> {
  const formData = new FormData()
  formData.append('title', input.title.trim())
  formData.append('description', input.description.trim())

  if (input.reporterEmail?.trim()) {
    formData.append('reporterEmail', input.reporterEmail.trim())
  }

  formData.append('pageUrl', input.pageUrl)
  formData.append('userAgent', input.userAgent)

  for (const screenshot of input.screenshots) {
    formData.append('screenshots', screenshot)
  }

  const response = await fetch('/api/bug-reports', {
    method: 'POST',
    body: formData,
  })

  const json = await response.json().catch(() => null)

  if (!response.ok) {
    const message = typeof json?.error === 'string'
      ? json.error
      : 'Could not submit bug report.'
    throw new BugReportSubmissionError(message, response.status)
  }

  return {
    id: json.id as string,
    emailSent: Boolean(json.emailSent),
  }
}
